import { render, staticRenderFns } from "./OrdersModal.vue?vue&type=template&id=6a8d47dc&scoped=true&"
import script from "./OrdersModal.vue?vue&type=script&lang=js&"
export * from "./OrdersModal.vue?vue&type=script&lang=js&"
import style0 from "./OrdersModal.vue?vue&type=style&index=0&id=6a8d47dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d47dc",
  null
  
)

export default component.exports